module.exports = __webpack_public_path__ + "img/start.eb14d3eb.png";